export function ConsentSettingsButton() {
  function reopenConsentMessage() {
    try {
      const googlefcWindow = window as Window & {
        googlefc?: {
          callbackQueue?: Array<Record<string, () => void>>;
          showRevocationMessage?: () => void;
        };
      };
      googlefcWindow.googlefc = googlefcWindow.googlefc || {};
      googlefcWindow.googlefc.callbackQueue = googlefcWindow.googlefc.callbackQueue || [];
      googlefcWindow.googlefc.callbackQueue.push({
        CONSENT_DATA_READY: () => {
          try {
            googlefcWindow.googlefc?.showRevocationMessage?.();
          } catch {
            // Google’s consent script can be unavailable or blocked.
          }
        },
      });
    } catch {
      // Consent settings are optional when Google’s script is unavailable.
    }
  }

  return (
    <button type="button" className="privacy-settings-button" onClick={reopenConsentMessage}>
      Privacy &amp; cookie settings
    </button>
  );
}
